import React from "react";
import { FormControl, Select, MenuItem, Checkbox } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  SET_SELECTED_DATASOURCE_IDS,
  SET_EDITING_DATASOURCE_ID,
  CLEAR_SYS_GUARD_TABLE_DATA,
  CLEAR_SYS_GUARD_FILTERS,
} from "./sysGuardConstants";
import { statusMapping } from "./sysGuardConstants";
import { icons } from "../../components/common/utilities";

const DataSourceSelector = ({ setIsEditMode, setOpenOnBoardingForm } = {}) => {
  const dispatch = useDispatch();

  const dataSourcesById = useSelector(
    (state) => state.SysGuardReducer.sysGuardDataSource,
  );

  const selectedDatasourceID = useSelector(
    (state) => state.SysGuardReducer.selectedDatasourceID,
  );

  const dataSources = Object.values(dataSourcesById);

  const handleChange = (event) => {
    if (event.target.value && event.target.value.length === 0) {
      return;
    }

    const value = event.target.value;

    dispatch({ type: CLEAR_SYS_GUARD_TABLE_DATA });
    dispatch({ type: CLEAR_SYS_GUARD_FILTERS });

    dispatch({
      type: SET_SELECTED_DATASOURCE_IDS,
      payload: typeof value === "string" ? value.split(",") : value,
    });
  };

  const getDataSourceIcon = (typeCode) => {
    return icons[typeCode];
  };

  return (
    <FormControl className="data-source-selector">
      <Select
        multiple
        variant="outlined"
        value={selectedDatasourceID}
        onChange={handleChange}
        className="data-source-select"
        displayEmpty
        renderValue={(selected) => {
          const visibleItems = selected.slice(0, 2);

          return (
            <div className="selected-datasource-wrapper">
              {visibleItems.map((id) => {
                const ds = dataSourcesById[id];

                return (
                  <div key={id} className="selected-datasource-chip">
                    <img
                      src={getDataSourceIcon(ds?.typeCode)}
                      alt={ds?.typeName}
                      className="selected-item-icon"
                    />

                    <span
                      className="selected-item-label"
                      title={ds?.domainName}
                    >
                      {ds?.domainName}
                    </span>
                  </div>
                );
              })}

              {selected.length > 2 && (
                <div className="selected-more-chip">+{selected.length - 2}</div>
              )}
            </div>
          );
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          PaperProps: {
            style: {
              maxHeight: 420,
              width: 460,
              borderRadius: 14,
              transform: "translateX(-15px)",
            },
          },
          getContentAnchorEl: null,
        }}
      >
        {dataSources.map((dataSource) => {
          return (
            <MenuItem
              key={dataSource.id}
              value={dataSource.id}
              className="sysguard-ds-selector"
            >
              <Checkbox
                checked={selectedDatasourceID.includes(dataSource.id)}
                color="primary"
              />

              <img
                src={getDataSourceIcon(dataSource.typeCode)}
                alt={dataSource.typeName}
                className="data-source-option-icon"
              />

              <div className="datasource-content">
                <div className="datasource-title" title={dataSource.domainName}>
                  {dataSource.domainName}
                </div>

                <div className="datasource-subtitle">{dataSource.typeName}</div>
              </div>

              <div
                className={`status-pill ${
                  dataSource.connectionStatus?.toLowerCase() || "error"
                }`}
                onClick={(e) => {
                  e.stopPropagation();

                  dispatch({
                    type: SET_EDITING_DATASOURCE_ID,
                    payload: dataSource.id,
                  });

                  setIsEditMode(true);
                  setOpenOnBoardingForm(true);
                }}
              >
                <span>{dataSource.connectionStatus || "Error"}</span>
              </div>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default DataSourceSelector;
